import { supabase } from '@/lib/supabase';
import { validateAndFormatPhone, getCountryFromPhone } from '@/utils/phoneUtils';

export function validatePhoneE164(
  e164: string,
  setError: (msg: string) => void
): boolean {
  if (!e164) return true;
  const countryCode = getCountryFromPhone(e164);
  if (!countryCode) return true;
  const validation = validateAndFormatPhone(e164, countryCode);
  if (!validation.isValid) {
    setError(validation.error || 'Invalid phone number');
    return false;
  }
  setError('');
  return true;
}

/** pathPrefix e.g. 'volunteers/userId' or 'organizations/userId' */
export async function uploadProfileImages(
  bucket: string,
  pathPrefix: string,
  profileFile: File | null,
  backgroundFile: File | null,
  currentProfile: string,
  currentBackground: string,
  clearBackground: boolean
): Promise<{ profileImage: string; backgroundImage: string }> {
  let finalProfile = currentProfile;
  let finalBackground = currentBackground;

  if (profileFile) {
    const ext = profileFile.name.split('.').pop();
    const path = `${pathPrefix}/profile_${Date.now()}.${ext}`;
    const { error } = await supabase.storage.from(bucket).upload(path, profileFile, {
      contentType: profileFile.type,
      upsert: true,
    });
    if (error) throw error;
    finalProfile = supabase.storage.from(bucket).getPublicUrl(path).data.publicUrl;
  }

  if (backgroundFile) {
    const ext = backgroundFile.name.split('.').pop();
    const path = `${pathPrefix}/background_${Date.now()}.${ext}`;
    const { error } = await supabase.storage.from(bucket).upload(path, backgroundFile, {
      contentType: backgroundFile.type,
      upsert: true,
    });
    if (error) throw error;
    finalBackground = supabase.storage.from(bucket).getPublicUrl(path).data.publicUrl;
  } else if (clearBackground) {
    finalBackground = '';
  }

  return { profileImage: finalProfile, backgroundImage: finalBackground };
}
